import * as React from 'react';
import Cached from 'material-ui/svg-icons/action/cached';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import * as storage from '@inqool/uas-web-core/es/utils/storage';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withConfiguration } from '@components/hoc/withConfiguration';
import { withClassname } from '@components/hoc/withClassname';

import { EventsForm } from '@modules/events/EventsForm';
import ActionBar from '@modules/events/EventsGridButtons';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const eventsUrl = '/metropolis/api/ed/events';
export const eventsLabel = 'Události';
export const eventsPath = '/events';
export const eventsGridName = 'module-events';

const rowStyleFn = item => {
  if (item && item.deleted) {
    return { backgroundColor: '#c4c4c4' };
  }
  if (item && item.lock) {
    return { backgroundColor: '#d9d9ff' };
  }
  if (item && item.state === 'OPEN') {
    return { backgroundColor: '#dbffdb' };
  } else if (item && item.state === 'CLOSED') {
    return { backgroundColor: '#ffd4d4' };
  } else if (item && item.state === 'PROCESSING') {
    return { backgroundColor: '#ffe3c7' };
  }
  return null;
};

export const EventsGrid = compose(
  withConfiguration({}),
  withRouter,
  setDisplayName('EventsGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: 'Události' }]),
  withColumns(Agenda.EVENTS),
  withProps(({ config: { settings: { eventColorActive } }, columns }) => {
    return {
      name: eventsGridName,
      url: '/metropolis/api/ed/events',
      Form: EventsForm,
      dialog: false,
      closeOnSave: false,
      gridProps: {
        deleteFiltersTooltip: 'Reset filtrů',
        deleteFiltersIcon: <Cached />,
        columns,
        ActionBar,
        filterRow: true,
        showCheckboxes: true,
        deleting: true,
        filtering: true,
        allowRestore: (() => {
          try {
            const permissions: Array<string> = JSON.parse(storage.get('permissions'));
            const ok = permissions.find(p => p === 'ROLE_DELETED_VIEW');
            return () => ok;
          } catch (e) {
            return () => false;
          }
        })(),
        ...(eventColorActive && { rowStyleFn }),
        sort: 'created',
        locale: 'cz',
        adding: true,
        pageSize: 50,
        version: 23
      }
    };
  }),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/events/EventsGrid.tsx